<div class="modals" v-if="hasActiveModals" :class="[currentModal, userStore.mobile ? 'modals--mobile' : '', sidebarAdjustment ? 'modals--sidebar' : '']">
    <div class="modals__modal" v-if="getModal('login').active">
        <div class="modal">
            <div class="modal__close" @click="closeModal('login')">
                <i class="fa-solid fa-xmark"></i>
            </div>
            <div class="modal__loader" v-if="isSubmitting" :style="{ 'background-image': 'url(' + getStaticImages('loading', 'png') + ')' }"></div>
            <modalLogin :page="false" v-on:onSubmit="loadLoader" />
        </div>
    </div>
    <div class="modals__modal" v-if="getModal('register').active">
        <div class="modal">
            <div class="modal__close" @click="closeModal('register')">
                <i class="fa-solid fa-xmark"></i>
            </div>
            <div class="modal__loader" v-if="isSubmitting" :style="{ 'background-image': 'url(' + getStaticImages('loading', 'png') + ')' }"></div>
            <modalRegister :page="false" v-on:onSubmit="loadLoader" />
        </div>
    </div>
    <div class="modals__modal" v-if="getModal('lostpassword').active">
        <div class="modal">
            <div class="modal__close" @click="closeModal('lostpassword')">
                <i class="fa-solid fa-xmark"></i>
            </div>
            <div class="modal__loader" v-if="isSubmitting" :style="{ 'background-image': 'url(' + getStaticImages('loading', 'png') + ')' }"></div>
            <modalLostPassword :page="false" v-on:onSubmit="loadLoader" />
        </div>
    </div>
    <div class="modals__modal" v-if="getModal('resetpassword').active">
        <div class="modal">
            <div class="modal__close" @click="closeModal('resetpassword')">
                <i class="fa-solid fa-xmark"></i>
            </div>
            <div class="modal__loader" v-if="isSubmitting" :style="{ 'background-image': 'url(' + getStaticImages('loading', 'png') + ')' }"></div>
            <modalResetPassword :page="false" v-on:onSubmit="loadLoader" />
        </div>
    </div>
    <div class="modals__modal" v-if="getModal('new').active">
        <div class="modal">
            <div class="modal__close" @click="closeModal('new')">
                <i class="fa-solid fa-xmark"></i>
            </div>
            <modalNew :page="false" />
        </div>
    </div>
    <div class="modals__modal small modals__modal-loader" v-if="getModal('loader').active">
        <div class="modal">
            <modalLoader :page="false" />
        </div>
    </div>
    <div class="modals__modal small" v-if="getModal('close').active">
        <div class="modal">
            <modalClose :page="false" />
        </div>
    </div>
    <div class="modals__modal" v-if="getModal('unlock').active">
        <div class="modal">
            <modalUnlock :page="false" />
        </div>
    </div>
    <div class="modals__modal large" v-if="getModal('cookiee').active">
        <div class="modal">
            <modalCookie :page="false" />
        </div>
    </div>
    <div class="modals__modal" v-if="getModal('payment').active">
        <div class="modal">
            <div class="modal__close" @click="closeModal('payment')">
                <i class="fa-solid fa-xmark"></i>
            </div>
            <modalPayment :page="false" />
        </div>
    </div>
    <div class="modals__modal" v-if="getModal('paysafe').active">        
        <div class="modal"> 
            <div class="modal__loader" v-if="isSubmitting" :style="{ 'background-image': 'url(' + getStaticImages('loading', 'png') + ')' }"></div>
            <modalPaysafe :page="false" v-on:onLoading="loadLoader" />
        </div>
    </div>
</div>
